import React, { useCallback, useEffect, useState } from 'react';

import cn from 'classnames';

import { IGoToTop } from '@features/GoToTop/model/types';

import cls from './GoToTop.module.css';

export const GoToTop = ({ containerRef }: IGoToTop) => {
    const [isOnTop, setIsOnTop] = useState(true);

    const handleScroll = useCallback(() => {
        if (!containerRef?.current) return;
        const { scrollTop } = containerRef.current;
        setIsOnTop(scrollTop < 10);
    }, [containerRef]);

    useEffect(() => {
        const container = containerRef?.current;
        if (!container) return;

        handleScroll();
        container.addEventListener('scroll', handleScroll);

        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll, containerRef]);

    const handleClick = () => {
        containerRef?.current?.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <span onClick={handleClick} className={cn(cls.GoToTop, isOnTop && cls.hidden)}>
            <span className={cls.svgSpan}>
                <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ transform: 'rotate(180deg)' }}
                >
                    <g clipPath="url(#clip0_95_191)">
                        <path
                            d="M18.8217 5.44086L10.5892 13.6734C10.4308 13.8256 10.2197 13.9107 10 13.9107C9.78033 13.9107 9.56918 13.8256 9.41084 13.6734L1.18334 5.44502L0.00500488 6.62336L8.2325 14.8517C8.70905 15.3059 9.34211 15.5592 10.0004 15.5592C10.6587 15.5592 11.2918 15.3059 11.7683 14.8517L20 6.61919L18.8217 5.44086Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_95_191">
                            <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0 0.5)"
                            />
                        </clipPath>
                    </defs>
                </svg>
            </span>
        </span>
    );
};
